export default __webpack_public_path__ + "static/media/upi-img.8b8a4208.jpg";